/* eslint-disable prefer-destructuring */
import React, { useState } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Swal from 'sweetalert2';

import { subscriptionConsultantPlans } from 'src/data/consultantSubscriptionPlans';

import FooterCheckout from 'src/components/functional/FooterCheckout';
import CheckoutHeader from 'src/components/functional/HeaderCheckout';
import { PurchaseResume } from './components/PurchaseResume';
import PurchaseForms from './components/PurchaseForms';

import { IConsultantData } from '../../interfaces';
import { apiCheckoutConsultant } from '../../api';

import { CheckoutComponent, ContainerCheckout, ContainerContent } from './style';

import loadingGIF from '../../../../assets/gifs/loading.png';
import PurchasePayment from './components/PurchasePayment';

export default function CheckoutConsultantPlan(): JSX.Element {
  const { token, platform, planId } = useParams();

  const [consultantData, setConsultantData] = useState<IConsultantData>();
  const [component, setComponent] = useState(0);

  const planData = subscriptionConsultantPlans.find((plan) => plan.planId === planId);

  const { isLoading, isError } = useQuery(
    ['getConsultantInfo', token],
    async () => apiCheckoutConsultant.getConsultantCheckoutInfo(token),
    {
      onError: () => {
        void Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro ao recuperar os dados!',
          text: 'Por favor, tente novamente mais tarde, ou contate a central.',
          iconColor: 'black',
          confirmButtonColor: 'black',
        });
      },
      onSuccess: (data) => {
        setConsultantData({
          consultantName: data.name,
          consultantEmail: data.email,
          zipCode: data.zipCode,
          consultantCpf: '',
          street: '',
          neighborhood: '',
          city: data.city,
          state: data.state,
          streetNumber: '',
          recipientId: data.recipientId,
          consultantPhone: data.phone,
        });
      },
      refetchOnWindowFocus: false,
    }
  );

  const renderComponent = (): JSX.Element => {
    if (component === 0)
      return (
        <PurchaseForms
          consultantData={consultantData}
          setConsultantData={setConsultantData}
          setComponent={setComponent}
        />
      );
    return (
      <PurchasePayment
        consultantData={consultantData}
        planData={planData}
        platform={platform}
        setComponent={setComponent}
      />
    );
  };

  return (
    <ContainerCheckout>
      <CheckoutHeader />
      <ContainerContent>
        <PurchaseResume planData={planData} />
        {isLoading || isError ? (
          <img src={loadingGIF} alt="Loading spinning" width="100" height="100" />
        ) : (
          <CheckoutComponent>{renderComponent()}</CheckoutComponent>
        )}
      </ContainerContent>
      <FooterCheckout />
    </ContainerCheckout>
  );
}
